<template>
    <div class="legalNotice">
        <div class="title">
            <h3>隐私保护</h3>
            <el-breadcrumb class="fl" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>隐私保护</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <h2>隐私保护</h2>
            <div class="wordBox">
                <h3>您的个人信息保护（Protection of Your Personal Information）</h3>
                <p>为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。 我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。 橙蟹会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，橙蟹将尽力做到使您的信息不被泄漏、毁损或丢失。 您的账户均有安全保护功能，请妥善保管您的账户及密码信息。橙蟹将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。 尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。 在使用橙蟹平台服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。 请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的账户及密码发生泄露，请您立即联络橙蟹客服，以便橙蟹采取相应措施。</p>
            </div>
            <div class="wordBox">
                <h3>未成年人保护（Juvenile Protection）</h3>
                <p>我们不会在知情的情况下收集未成年人的个人信息，也不建议未成年人使用我们的服务。 除非所在地法律允许并且监护人同意，未成年人请不要注册账户或发送自己的姓名、住址、电话、邮件地址等个人信息给我们。如果我们不小心收集到了未成年人的信息，我们在知情后会尽快删除。 如果您认为我们可能不当地持有来自于或关于未成年人的信息，请联系我们。</p>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'legalNotice',
        data() {
            return {

            }
        }
    }
</script>

<style scoped>
    .title {
        width: 70%;
        padding: 2% 15%;
        background-color: #2e324f;
        color: #fff
    }

    .title h3 {
        font-size: 20px;
    }

    .content {
        width: 70%;
        padding: 2% 15%;
    }

    .wordBox {
        padding: 1% 6%;
    }

    .content h2 {
        text-align: center;
        color: #000000;
    }

    .content h3 {
        color: #010010;
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/privacy.vue